// ────────────────────────────────────────────────────────────────
// shared/prd-confirm/prd-confirm-dialog.ts — the typed-confirmation UI
// Mounted once in the shell. Loudly red; the confirm button stays
// disabled until the admin types the literal env code `prd`.
// ────────────────────────────────────────────────────────────────

import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PrdConfirmService } from './prd-confirm.service';

const CONFIRM_WORD = 'prd';

@Component({
  selector: 'app-prd-confirm-dialog',
  imports: [Dialog, ButtonModule, InputTextModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prd-confirm-dialog.html',
  styleUrl: './prd-confirm-dialog.scss',
})
export class PrdConfirmDialog {
  private readonly service = inject(PrdConfirmService);

  readonly pending = this.service.pending;
  readonly typed = signal('');
  readonly canConfirm = computed(() => this.typed().trim().toLowerCase() === CONFIRM_WORD);

  onTyped(value: string): void {
    this.typed.set(value);
  }

  confirm(): void {
    if (!this.canConfirm()) return;
    this.typed.set('');
    this.service.accept();
  }

  cancel(): void {
    this.typed.set('');
    this.service.cancel();
  }
}
